import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetEmailSuggestions'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetEmailSuggestionsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetEmailSuggestionsStore",
			variables: false,
		})
	}
}

export async function load_GetEmailSuggestions(params) {
  await initClient()

	const store = new GetEmailSuggestionsStore()

	await store.fetch(params)

	return {
		GetEmailSuggestions: store,
	}
}
